package team.platforma.aicombo.theme.colors

import androidx.compose.ui.graphics.Color

object AppColors {
    private var mSurface: Color = Color.White
    fun surface() = mSurface

    private var mBackgroundDisabled: Color = Color.White
    fun backgroundDisable() = mBackgroundDisabled

    object bg {
        private var mBase: BackgroundBase = BackgroundBase()
        fun base() = mBase

        private var mDefault: BackgroundDefault = BackgroundDefault()
        fun default() = mDefault

        private var mPrimary: BackgroundPrimary = BackgroundPrimary()
        fun primary() = mPrimary

        private var mPrimaryInvert: BackgroundPrimaryInvert =
            BackgroundPrimaryInvert()

        fun primaryInvert() = mPrimaryInvert

        private var mSuccess: BackgroundSuccess = BackgroundSuccess()
        fun success() = mSuccess

        private var mWarning: BackgroundWarning = BackgroundWarning()
        fun warning() = mWarning

        private var mError: BackgroundError = BackgroundError()
        fun error() = mError

        private var mInformation: BackgroundInformation = BackgroundInformation()
        fun info() = mInformation

        fun define(
            base: BackgroundBase,
            default: BackgroundDefault,
            primary: BackgroundPrimary,
            primaryInvert: BackgroundPrimaryInvert,
            success: BackgroundSuccess,
            warning: BackgroundWarning,
            error: BackgroundError,
            info: BackgroundInformation
        ) {
            mBase = base
            mDefault = default
            mPrimary = primary
            mPrimaryInvert = primaryInvert
            mSuccess = success
            mWarning = warning
            mError = error
            mInformation = info
        }
    }

    private var mTextColor: TextColors = TextColors(
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White
    )

    fun text() = mTextColor

    private var mBorderColor: BorderColors = BorderColors(
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White,
        Color.White
    )

    fun border() = mBorderColor

    fun define(
        surfaceColor: Color,
        backgroundDisabledColor: Color,
        base: BackgroundBase,
        default: BackgroundDefault,
        primary: BackgroundPrimary,
        primaryInvert: BackgroundPrimaryInvert,
        success: BackgroundSuccess,
        warning: BackgroundWarning,
        error: BackgroundError,
        info: BackgroundInformation,
        text: TextColors,
        border: BorderColors
    ) {
        mSurface = surfaceColor
        mBackgroundDisabled = backgroundDisabledColor
        bg.define(
            base,
            default,
            primary,
            primaryInvert,
            success,
            warning,
            error,
            info
        )
        mTextColor = text
        mBorderColor = border
    }
}

open class BackgroundColor(
    open val default: Color,
    open val hover: Color,
    open val press: Color,
    open val focus: Color,
    open val loading: Color
)

data class BackgroundBase(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundDefault(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundPrimary(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundPrimaryInvert(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundSuccess(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundWarning(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundError(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class BackgroundInformation(
    override val default: Color = Color.White,
    override val hover: Color = Color.White,
    override val press: Color = Color.White,
    override val focus: Color = Color.White,
    override val loading: Color = Color.White
) : BackgroundColor(default, hover, press, focus, loading)

data class TextColors(
    val light: Color,
    val base: Color,
    val default: Color,
    val primary: Color,
    val placeholder: Color,
    val caption: Color,
    val link: Color,
    val visited: Color,
    val success: Color,
    val info: Color,
    val warning: Color,
    val error: Color,
    val disabled: Color
)

data class BorderColors(
    val default: Color,
    val primary: Color,
    val focus: Color,
    val info: Color,
    val success: Color,
    val warning: Color,
    val error: Color,
    val disabled: Color,
    val dark: Color
)